import { FormControl, type IFormikFormControlProps } from './FormControl'
import { type ISelectProps, Select } from '../../elements/Select/'

interface IFormSelectProps<OptionType>
  extends
    Omit<IFormikFormControlProps, 'children'>,
    Omit<ISelectProps<OptionType>, 'id' | 'name'> {}

export const FormSelect = <OptionType, _ = any>(
  props: IFormSelectProps<OptionType>
) => {
  const {
    name,
    disabled,
    id,
    layout,
    label,
    labelIcon,
    labelBadge,
    labelTooltipMessage,
    labelTooltipAriaLabel,
    helperText,
    required,
    fullWidth = true,

    ...SelectProps
  } = props
  const inputId = `${id}-input`

  return (
    <FormControl
      name={name}
      disabled={disabled}
      id={id}
      layout={layout}
      label={label}
      labelIcon={labelIcon}
      labelBadge={labelBadge}
      labelTooltipMessage={labelTooltipMessage}
      labelTooltipAriaLabel={labelTooltipAriaLabel}
      helperText={helperText}
      required={required}
      fullWidth={fullWidth}
      labelFor={inputId}
    >
      {({
        value,
        handleChange,
        handleBlur,
        isSubmitting,
        error,
        helperTextId,
      }) => (
        <Select<OptionType>
          name={props.name}
          id={id}
          inputId={inputId}
          isDisabled={isSubmitting || disabled}
          value={value}
          onChange={handleChange}
          onBlur={handleBlur}
          error={error}
          aria-required={required || undefined}
          aria-invalid={error || undefined}
          {...SelectProps}
          aria-describedby={
            [SelectProps['aria-describedby'], helperTextId]
              .filter(Boolean)
              .join(' ') || undefined
          }
        />
      )}
    </FormControl>
  )
}

FormSelect.displayName = 'Form.Select'
